export const FOLDER_PAGE_SIZE = 250;

export const FOLDER_NAME_ERRORS = {
  NOT_UNIQUE_NAME: 'You already have a folder with this name.',
  TOO_LONG: 'Folder name cannot exceed 200 characters.',
  TOO_SHORT: 'Folder name is too short.',
};
